var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134.11 170.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M84.75,207.66A471.17,471.17,0,0,1,51.41,170c-9.72-12.33-17.47-23.71-23-33.83-6.93-12.62-10.45-23.28-10.45-31.68a66.49,66.49,0,0,1,5.25-26A66.72,66.72,0,0,1,37.51,57.2a66.77,66.77,0,0,1,94.48,0,67.61,67.61,0,0,1,8.15,9.88,66.51,66.51,0,0,1,11.41,37.36c0,8.4-3.51,19.06-10.44,31.68a253.94,253.94,0,0,1-23,33.84A473,473,0,0,1,84.75,207.66Z",
    transform: "translate(-17.69 -37.38)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M84.75,37.88A66.52,66.52,0,0,0,37.69,57.37,66.65,66.65,0,0,0,23.42,78.53a66.13,66.13,0,0,0-5.23,25.91c0,8.36,3.51,19,10.42,31.56a252,252,0,0,0,23,33.8,473.08,473.08,0,0,0,33.14,37.51,474.06,474.06,0,0,0,33.13-37.51,251.86,251.86,0,0,0,23-33.8c6.91-12.58,10.41-23.2,10.41-31.56a66.38,66.38,0,0,0-11.36-37.22,66.83,66.83,0,0,0-18-18A66.23,66.23,0,0,0,84.75,37.88m0-.5a67.05,67.05,0,0,1,67.05,67.06c0,37-67.05,103.58-67.05,103.58S17.69,141.47,17.69,104.44A67.06,67.06,0,0,1,84.75,37.38Z",
    transform: "translate(-17.69 -37.38)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 66.31,
    r: 50,
    fill: "#64bec6",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.f64b117766fcbf69649a346f93887e4d.svg";
export { ForwardRef as ReactComponent };